'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.getLayoutData = exports.getSerieDataWithoutMissingLines = exports.getSerieDataWithMissingLines = undefined;

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _ramda = require('ramda');

var R = _interopRequireWildcard(_ramda);

var _getFlagsAndNotes = require('./getFlagsAndNotes');

var _utils = require('../utils');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getValueData = function getValueData(index, dimension, parentsIndexes) {
	var missingParents = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
	return {
		dimension: R.pick(['id', 'name', '__index'], dimension),
		value: (0, _extends3.default)({}, R.pipe(R.pathOr({}, ['values', index]), R.pick(['id', 'name', 'isNonCoded', 'flags', 'hasAdvancedAttributes']))(dimension), {
			parents: parentsIndexes,
			missingParents: missingParents
		})
	};
};

var addCoordinatesToKey = function addCoordinatesToKey(key, dimensionId, valueId) {
	return '' + key + (R.isEmpty(key) ? '' : ':') + dimensionId + '=' + valueId;
};

var simpleValueDataSetter = function simpleValueDataSetter(valueData) {
	var datas = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	return R.append(valueData, datas);
};

var combinedValueDataSetter = function combinedValueDataSetter(valueData) {
	var datas = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	return R.over(R.lensIndex(-1), function (d) {
		return (0, _extends3.default)({}, d, { values: R.append(R.prop('value', valueData), d.values) });
	}, datas);
};

var addValueToSerieData = function addValueToSerieData(dataSetter) {
	return function (index, parentsIndexes, dimension, serieData, missingParents) {
		var valueData = getValueData(index, dimension, parentsIndexes, missingParents);
		var valueId = R.path(['value', 'id'], valueData);
		return (0, _extends3.default)({}, serieData, {
			data: dataSetter(valueData, R.prop('data', serieData)),
			key: addCoordinatesToKey(R.prop('key', serieData), R.prop('id', dimension), valueId)
		});
	};
};

var addSimpleValueToSerieData = addValueToSerieData(simpleValueDataSetter);

var addCombinedValueToSerieData = addValueToSerieData(combinedValueDataSetter);

var getHasAdvancedAttributes = function getHasAdvancedAttributes(attrValues, customAttributes) {
	return R.pipe(R.omit(R.concat(customAttributes.flags || [], customAttributes.notes || [])), R.isEmpty, R.not)(attrValues);
};

var getCoordinates = function getCoordinates(indexes, topCoordinates, definition) {
	return R.addIndex(R.reduce)(function (acc, entry, index) {
		if (R.has('dimensions', entry)) {
			return R.addIndex(R.reduce)(function (_acc, dim, _index) {
				var valInd = R.path([index, _index], indexes);
				return R.assoc(dim.id, R.path(['values', Math.abs(valInd), 'id'], dim), _acc);
			}, acc, entry.dimensions);
		}
		var valInd = R.nth(index, indexes);
		return R.assoc(entry.id, R.path(['values', Math.abs(valInd), 'id'], entry), acc);
	}, topCoordinates, definition);
};

var getAttributesSeries = function getAttributesSeries(validator, attributesSeries) {
	return R.reduce(function (acc, attrs) {
		var attr = R.head(R.values(attrs)) || {};
		if (R.length(attr.relationship || []) === 1 && !attr.combined) {
			return acc;
		}
		var coordinates = R.propOr({}, 'coordinates', attr);
		var isValid = validator(coordinates);
		if (!isValid && !R.prop('isObs', attr)) {
			return acc;
		}
		return (0, _extends3.default)({}, acc, attrs);
	}, {}, R.values(attributesSeries));
};

var combineConcepts = function combineConcepts(combDimValues, definition, attrValues) {
	return R.over(R.lensProp('data'), R.over(R.lensIndex(-1), function (data) {
		return (0, _extends3.default)({}, data, {
			values: R.reduce(function (acc, conceptId) {
				if (R.has(conceptId, combDimValues)) {
					return R.append(R.prop(conceptId, combDimValues), acc);
				}
				if (R.has(conceptId, definition.fixedDimValues || {})) {
					return R.append(R.prop(conceptId, definition.fixedDimValues), acc);
				}
				if (R.has(conceptId, attrValues)) {
					var value = R.path([conceptId, 'value'], attrValues);
					return R.append(value, acc);
				}
				return acc;
			}, [], definition.concepts)
		});
	}));
};

var getSerieFlagsAndSideProps = function getSerieFlagsAndSideProps(coordinates, validator, attributesValues, customAttributes, metadataCoordinates, data) {
	var layoutAttrValues = R.reject(function (attr) {
		return R.prop('isObs', attr) && !validator(attr.coordinates);
	}, attributesValues);
	var flags = (0, _getFlagsAndNotes.getFlagsAndNotes)(layoutAttrValues, customAttributes);
	var hasMetadata = !R.isNil(R.find(validator, metadataCoordinates));
	var hasDataAdvancedAttributes = R.any(function (d) {
		return R.has('value', d) ? R.prop('hasAdvancedAttributes', d.value) : R.any(R.prop('hasAdvancedAttributes'), d.values);
	}, data);
	var hasAdvancedAttributes = hasDataAdvancedAttributes || getHasAdvancedAttributes(layoutAttrValues, customAttributes);
	var sideProps = hasMetadata || hasAdvancedAttributes ? { hasMetadata: hasMetadata, hasAdvancedAttributes: hasAdvancedAttributes, coordinates: coordinates } : null;
	return { flags: flags, sideProps: sideProps };
};

var getSerieDimensionsData = function getSerieDimensionsData(serie, definition, attributesValues, missingParentsGetter) {
	return R.addIndex(R.reduce)(function (onGoingSerie, entry, index) {
		if (R.has('dimensions', entry)) {
			var combValuesIndexes = R.pathOr([], ['indexes', index], serie);
			var combParentsIndexes = R.pathOr([], ['parentsIndexes', index], serie);
			var combMissingParentsIndexes = R.pathOr([], ['missingIndexes', index], serie);
			var combDimValues = {};
			var res = R.addIndex(R.reduce)(function (combSerie, dimension, dimIndex) {
				var valueIndex = Math.abs(R.nth(dimIndex, combValuesIndexes));
				var _parentsIndexes = R.nth(dimIndex, combParentsIndexes) || [];
				var missingParentsIndexes = R.nth(dimIndex, combMissingParentsIndexes) || [];

				var _missingParentsGetter = missingParentsGetter(combinedValueDataSetter)(missingParentsIndexes, _parentsIndexes, dimension, combSerie),
				    parentsIndexes = _missingParentsGetter.parentsIndexes,
				    missingParents = _missingParentsGetter.missingParents;

				var next = addCombinedValueToSerieData(valueIndex, parentsIndexes, dimension, combSerie, missingParents);
				var value = R.pipe(R.prop('data'), R.last, R.prop('values'), R.last)(next);
				combDimValues = R.assoc(dimension.id, value, combDimValues);
				return next;
			}, R.over(R.lensProp('data'), R.append({ dimension: R.pick(['id', 'name'], entry), values: [] }))(onGoingSerie), R.propOr([], 'dimensions', entry));

			var combined = combineConcepts(combDimValues, entry, onGoingSerie.attributes)(res);
			return R.over(R.lensProp('attributes'), R.omit(entry.concepts), combined);
		}

		var valueIndex = Math.abs(R.path(['indexes', index], serie));
		var _parentsIndexes = R.pathOr([], ['parentsIndexes', index], serie);
		var missingParentsIndexes = R.pathOr([], ['missingIndexes', index], serie);

		var _missingParentsGetter2 = missingParentsGetter(simpleValueDataSetter)(missingParentsIndexes, _parentsIndexes, entry, onGoingSerie),
		    parentsIndexes = _missingParentsGetter2.parentsIndexes,
		    missingParents = _missingParentsGetter2.missingParents;

		return addSimpleValueToSerieData(valueIndex, parentsIndexes, entry, onGoingSerie, missingParents);
	}, { data: [], key: '', attributes: attributesValues }, definition);
};

var getSerieDataWithMissingLines = function getSerieDataWithMissingLines(serie, definition, topCoordinates, attributesSeries, customAttributes, metadataCoordinates) {
	var lines = [];

	var serieCoordinates = getCoordinates(serie.indexes, topCoordinates, definition);
	var coordinatesValidator = (0, _utils.getLayoutCoordinatesValidator)(serieCoordinates, topCoordinates);
	var attributesValues = getAttributesSeries(coordinatesValidator, attributesSeries);

	var getMissingParents = function getMissingParents(dataSetter) {
		return function (missingParentsIndexes, _parentsIndexes, dim, serieData) {
			return R.reduce(function (acc, index) {
				var missingParentData = addValueToSerieData(dataSetter)(index, acc.parentsIndexes, dim, serieData);
				lines.push((0, _extends3.default)({}, R.dissoc('attributes', missingParentData), { sideProps: null, flags: [], isEmpty: true }));
				return R.over(R.lensProp('parentsIndexes'), R.append(index), acc);
			}, { parentsIndexes: _parentsIndexes, missingParents: [] }, missingParentsIndexes);
		};
	};

	var _getSerieDimensionsDa = getSerieDimensionsData(serie, definition, attributesValues, getMissingParents),
	    attributes = _getSerieDimensionsDa.attributes,
	    serieData = (0, _objectWithoutProperties3.default)(_getSerieDimensionsDa, ['attributes']);

	var topCoordinatesValidator = (0, _utils.getLayoutCoordinatesValidator)(topCoordinates);
	var flagsValidator = function flagsValidator(coordinates) {
		return coordinatesValidator(coordinates) && !topCoordinatesValidator(coordinates);
	};

	var _getSerieFlagsAndSide = getSerieFlagsAndSideProps(serieCoordinates, flagsValidator, attributes, customAttributes, metadataCoordinates, serieData.data),
	    flags = _getSerieFlagsAndSide.flags,
	    sideProps = _getSerieFlagsAndSide.sideProps;

	return R.append((0, _extends3.default)({}, serieData, { flags: flags, sideProps: sideProps, coordinates: serieCoordinates }), lines);
};

exports.getSerieDataWithMissingLines = getSerieDataWithMissingLines;
var getSerieDataWithoutMissingLines = function getSerieDataWithoutMissingLines(serie, definition, topCoordinates, attributesSeries, customAttributes, metadataCoordinates) {
	var serieCoordinates = getCoordinates(serie.indexes, topCoordinates, definition);
	var coordinatesValidator = (0, _utils.getLayoutCoordinatesValidator)(serieCoordinates, topCoordinates);
	var attributesValues = getAttributesSeries(coordinatesValidator, attributesSeries);

	var getMissingParents = function getMissingParents() {
		return function (missingParentsIndexes, _parentsIndexes, dim) {
			return R.reduce(function (acc, index) {
				return {
					parentsIndexes: R.append(index, acc.parentsIndexes),
					missingParents: R.append(R.prop('value', getValueData(index, dim, acc.parentsIndexes)), acc.missingParents)
				};
			}, { parentsIndexes: _parentsIndexes, missingParents: [] }, missingParentsIndexes);
		};
	};

	var _getSerieDimensionsDa2 = getSerieDimensionsData(serie, definition, attributesValues, getMissingParents),
	    attributes = _getSerieDimensionsDa2.attributes,
	    serieData = (0, _objectWithoutProperties3.default)(_getSerieDimensionsDa2, ['attributes']);

	var _getSerieFlagsAndSide2 = getSerieFlagsAndSideProps(serieCoordinates, coordinatesValidator, attributes, customAttributes, metadataCoordinates, serieData.data),
	    flags = _getSerieFlagsAndSide2.flags,
	    sideProps = _getSerieFlagsAndSide2.sideProps;

	return (0, _extends3.default)({}, serieData, { flags: flags, sideProps: sideProps, coordinates: serieCoordinates });
};

exports.getSerieDataWithoutMissingLines = getSerieDataWithoutMissingLines;
var getLayoutData = function getLayoutData(layoutIndexes, layout, _ref) {
	var metadataCoordinates = _ref.metadataCoordinates,
	    attributesSeries = _ref.attributesSeries,
	    customAttributes = _ref.customAttributes,
	    _ref$topCoordinates = _ref.topCoordinates,
	    topCoordinates = _ref$topCoordinates === undefined ? {} : _ref$topCoordinates;
	var header = layoutIndexes.header,
	    sections = layoutIndexes.sections,
	    rest = (0, _objectWithoutProperties3.default)(layoutIndexes, ['header', 'sections']);

	var headerData = R.reduce(function (acc, serie) {
		var datas = getSerieDataWithMissingLines(serie, layout.header, topCoordinates, attributesSeries, customAttributes, metadataCoordinates);
		return R.concat(acc, datas);
	}, [], header);

	var sectionsData = R.map(function (_ref2) {
		var _ref3 = (0, _slicedToArray3.default)(_ref2, 2),
		    sectionSerie = _ref3[0],
		    rowsSeries = _ref3[1];

		var sectionData = getSerieDataWithoutMissingLines(sectionSerie, layout.sections, topCoordinates, attributesSeries, customAttributes, metadataCoordinates, false);
		return [sectionData, R.reduce(function (acc, serie) {
			var datas = getSerieDataWithMissingLines(serie, layout.rows, R.propOr(topCoordinates, 'coordinates', sectionData), attributesSeries, customAttributes, metadataCoordinates);
			return R.concat(acc, datas);
		}, [], rowsSeries)];
	}, sections);

	return (0, _extends3.default)({ headerData: headerData, sectionsData: sectionsData }, rest);
};
exports.getLayoutData = getLayoutData;